import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSerializer } from '@angular/router';
import { AuthService, RegistrationModel } from 'angular-lib';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(
        private auth: AuthService,
        private router: Router,
        private location: Location
    ) {
    }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let params = route.queryParams;
        if (this.auth.loggedIn() === false && params.jwt !== undefined) {
            AuthService.login(params.jwt);

            let httpParams = {};
            for (let param in params) {
                if (param !== 'jwt') {
                    httpParams[param] = params[param];
                }
            }

            let path = this.location.path();
            let url = path.substring(0, path.indexOf('?'));
            this.router.navigate([url], {queryParams: httpParams, replaceUrl: true});
        }

        if (this.auth.loggedIn()) {
            return true;
        } else {
            AuthService.logout();
            this.router.navigate(['/login']);
            return false;
        }
    }
}

@Injectable()
export class NoAuthGuardService implements CanActivate {

    constructor(private auth: AuthService, private router: Router) {}

    public canActivate(): boolean {
        if (!this.auth.loggedIn()) {
            return true;
        } else {
            if (RegistrationModel.initFromLocalStorage()) {
                this.router.navigate(['/registration']);
            } else {
                this.router.navigate(['/member/search']);
            }
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/guards/auth-guard.service.ts